
import Vue, { PropType } from 'vue'
import { IProductAnalogueItem, IProductMnn } from 'types/DTO/products'

export default Vue.extend({
  name: 'RPHAnalogsList',
  components: {
    RPHAnalogsGrid: () => import('rph/organisms/RPHAnalogsGrid/index.vue'),
    Heading: () => import('~/components/atoms/Heading.vue'),
  },

  props: {
    analogs: {
      type: Array as PropType<IProductAnalogueItem[]>,
      default: () => [],
    },
    analogsLink: {
      type: String,
      default: '',
    },
    analogsCount: {
      type: String,
      default: '',
    },
    mnns: {
      type: Array as PropType<IProductMnn[]>,
      default: () => [],
    },
    isRecommended: {
      type: Boolean,
      default: false,
    },
  },
})
